const authService = {
    getToken(){
        const token = localStorage.getItem("token");
        // Guard: localStorage.setItem('token', null) stores the STRING "null".
        // Treat "null" / "undefined" / empty as no token so we don't send a bad header.
        return (token && token !== 'null' && token !== 'undefined') ? token : null;
    },
    setToken(token){
        if (token && token !== 'null' && token !== 'undefined') {
            localStorage.setItem("token", token);
        } else {
            localStorage.removeItem("token");
        }
    },
    logout(){
        localStorage.removeItem("token");
    }
};

export default authService;